<template>
  <div class="shckliebiao">
    <div style="background-color: white; border-radius: 5px">
      <div class="headerSearch">
        <el-form
          :model="formInline"
          style="display: flex"
          class="demo-form-inline"
          label-width="90px"
          label-position="left"
        >
          <el-form-item label="化学品:">
            <el-input v-model="formInline.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-select v-model="formInline.ckmc" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in ckmcList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出库日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="formInline.sqKs"
                type="date"
                style="width: 100%"
                placeholder="开始时间"
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="formInline.sqJs"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="状态:" label-width="50px">
            <el-select v-model="formInline.zt" placeholder="请选择">
              <el-option
                v-for="(item, k) in ztSX"
                :key="k"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            type="primary"
            class="sousuoButton"
            size="small"
            icon="el-icon-search"
            @click="onSubmit"
          >搜索</el-button>
          <el-button
            v-preventReClick
            class="resetbutton"
            size="small"
            icon="el-icon-refresh-right"
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
    </div>

    <div class="shckTableContain">
      <div class="tableXS">
        <div class="addmesbgc">
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-plus"
            class="addmes"
            size="mini"
            @click="addMes"
          >新增</el-button>
          <el-button
            v-preventReClick
            icon="el-icon-upload"
            size="mini"
            class="addmes"
            @click="exportlb"
          >导出</el-button>
        </div>

        <el-table
          ref="filterTable"
          :data="tableData"
          style="width: 100%"
          border
          :cell-style="cellStyle"
        >
          <el-table-column
            label="出库编号"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.ckbh }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="仓库名称"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.ckmc }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="化学品名称"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.hxpMc }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="损耗数量"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span
                  v-if="!isEmpty(scope.row.cksl)"
                size="medium"
              >{{ scope.row.cksl
              }}</span>
              <span size="medium" v-if="!isEmpty(scope.row.ckslDwLabel)">{{"(" + scope.row.ckslDwLabel + ")" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="损耗原因"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.shyy }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="出库日期"
            :show-overflow-tooltip="true"
            align="center"
            prop="ckrq"
          >
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.ckrq }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="变更次数"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-preventReClick
                style="cursor: pointer"
                @click="bgcsClick(scope.row)"
              >{{ scope.row.bgcs }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ztLabel }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.zt != '00'"
                v-preventReClick
                size="mini"
                icon="el-icon-document"
                style="background-color: #4170ff; border: none; color: white"
                @click="handleSelect(scope.row.id, scope.row)"
              >查看</el-button>
              <el-button
                v-if="scope.row.zt == '01'"
                v-preventReClick
                size="mini"
                icon="el-icon-edit"
                style="background-color: #feb800; border: none; color: white"
                @click="handleChange(scope.row.id, scope.row)"
              >变更</el-button>
              <el-button
                v-if="scope.row.zt == '11'"
                disabled
                size="mini"
                icon="el-icon-edit"
                style="background-color: #c8c9cc; border: none; color: white"
              >变更</el-button>
              <el-button
                v-if="scope.row.zt == '00'"
                v-preventReClick
                size="mini"
                icon="el-icon-edit"
                style="background-color: #4170ff; border: none; color: white"
                @click="handleEdit(scope.row.id)"
              >编辑</el-button>
              <el-button
                v-if="scope.row.zt == '00'"
                v-preventReClick
                size="mini"
                icon="el-icon-delete"
                style="background-color: #ff5721; border: none; color: white"
                @click="deleteItem(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <shckdialog
      v-if="dialogFormVisible"
      :dialog-form-visible="dialogFormVisible"
      :djsjshow="djsjshow"
      ref="dialogshck"
      :ckdisable="ckdisable"
      :bgdisable="bgdisable"
      :children-type="childrenType"
      :row-id="rowId"
      :shcktype="type"
      @close-dialog="closeDialog"
    />
  </div>
</template>

<script>
// 获取接口地址
import {
  getListCkcx,
  getshcklistMes,
  exportshckList,
  statusOptionsNew,
  deleteshckMes
} from '@/assets/js/common.js'
import shckdialog from './shckDialog.vue'
import bgcs from '@/components/bgcs'
import {isEmpty} from "@/utils/tool";
export default {
  name: 'Shcklb',
  components: { shckdialog, bgcs },
  data() {
    return {
      bgcsTKName: '损耗出库',
      startTime: {
        disabledDate: (time) => {
          if (this.formInline.sqJs) {
            return time.getTime() > new Date(this.formInline.sqJs).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formInline.sqKs) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.formInline.sqKs).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      childrenType: '',
      // 登记时间隐藏
      djsjshow: false,
      // 查看不可编辑
      ckdisable: false,
      // 变更便捷
      bgdisable: false,
      formInline: {
        name: '',
        ckmc: '',
        sqKs: '',
        sqJs: '',
        zt: ''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0,
      dialogFormVisible: false, // 对话框的显示隐藏
      type: false, // 添加和编辑，可编辑，查看不可编辑
      tableData: [],
      ztSX: [], // 状态筛选
      ckmcList: [],
      rowId: ''
    }
  },

  created() {
    statusOptionsNew().then((res) => {
      if (res.status == 200) {
        this.ztSX = res.data.data
      }
    })
    // 获取首页仓库下拉
    getListCkcx().then((res) => {
      if (res.status == 200) {
        this.ckmcList = res.data.data
      }
    })
    this.search()
  },
  mounted() {},
  methods: {
    isEmpty,
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '8')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 点击添加按钮
    addMes() {
      this.dialogFormVisible = true
      // this.type = false;
      this.djsjshow = false
      this.ckdisable = false
      this.bgdisable = false
      this.childrenType = '新增'
      setTimeout(() => {
        this.$refs.dialogshck.initCon({}, 8)
      }, 30)
    },
    // 编辑
    handleEdit(rowId) {
      this.dialogFormVisible = true
      // this.type = false;
      this.djsjshow = true
      this.ckdisable = false
      this.bgdisable = false
      this.childrenType = '编辑'
      this.rowId = rowId

      setTimeout(() => {
        this.$refs.dialogshck.initCon({}, 8)
      }, 30)
    },
    // 查看
    handleSelect(rowId, row) {
      this.dialogFormVisible = true
      // this.type = true;
      this.djsjshow = true
      this.ckdisable = true
      this.bgdisable = false
      this.childrenType = '查看'
      this.rowId = rowId

      setTimeout(() => {
        this.$refs.dialogshck.initCon(row, 8)
      }, 30)
    },
    // 变更
    handleChange(rowId, row) {
      this.dialogFormVisible = true
      // this.type = true;
      this.djsjshow = true
      this.ckdisable = false
      this.bgdisable = true
      this.childrenType = '变更'
      this.rowId = rowId

      setTimeout(() => {
        this.$refs.dialogshck.initCon(row, 8)
      }, 30)
    },
    // 删除
    deleteItem(rowId) {
      this.$confirm('确认选择当前库存信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then((res) => {
          deleteshckMes(rowId).then((res) => {
            this.search()
            this.$message.success('删除成功!')
          })
        })
        .catch((err) => {
          return
        })
    },
    // 点击重置时
    reset() {
      this.formInline = {
        name: '',
        ckmc: '',
        sqKs: '',
        sqJs: '',
        zt: ''
      }
      this.currentPage = 1
      this.pagesize = 10
      // 调用查询接口
      this.search()
    },
    // 导出
    exportlb() {
      exportshckList({
        param: {
          hxpMc: this.formInline.name,
          ckId: this.formInline.ckmc,
          beginCkrq: this.formInline.sqKs,
          endCkrq: this.formInline.sqJs,
          zt: this.formInline.zt
        }
      })
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '损耗出库'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    search() {
      getshcklistMes({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.formInline.name,
          ckId: this.formInline.ckmc,
          beginCkrq: this.formInline.sqKs,
          endCkrq: this.formInline.sqJs,
          zt: this.formInline.zt
        }
      }).then((res) => {
        if (res.status == 200) {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '24':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '21':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '23':
            cellStyle = 'color: #ff0000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    // 点击搜索时
    onSubmit() {
      this.currentPage = 1
      this.search()
    },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.sousuoButton {
  width: 90px;
  height: 39px;
  background: hsl(225, 100%, 63%);
  border-radius: 20px;
  border-color: #4170ff;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.el-button--primary {
  color: #fff;
  background-color: #4170ff;
  border-color: #4170ff;
}
/deep/ .el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;
  border: 1px solid #ebeef5;
  border-top: 0;
}
.shckliebiao {
  width: 95%;
  margin: 0 auto;
  // background-color: white;
  max-width: 1518px;
  .headerSearch {
    margin: 0 auto;
    padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    margin-top: 30px;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form {
      width: 90%;
      margin: auto;
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
    }
  }
  .shckTableContain {
    margin-left: auto;
    margin-right: auto;
    margin-top: 11px;
    background-color: white;
    padding-top: 40px;
    padding-bottom: 57px;

    .tableXS {
      width: 90%;
      margin: 0 auto;
      /deep/ .el-table {
        z-index: 0;
      }
      /deep/ .el-table .has-gutter tr th {
        background: rgb(242, 242, 242);
      }
      .addmesbgc {
        background: rgb(242, 242, 242);
        padding: 12px 10px;
        border-bottom: 1px solid #ebeef5;
        .addmes:nth-child(1) {
          // margin: 15px;
          border: none;
        }
      }
    }
  }
}

.el-form-item__label {
  height: 41px;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
